import { FC } from "react";
import { useStyles } from "./Toolbar";

export const MenuTitle: FC = ({ children }) => {
  const styles = useStyles();

  return <div className={styles.toolbarMenuHeader}>{children}</div>;
};
